import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const DataboxIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path
      d="M1.86653 14.8223L2.02208 14.7223L2.25542 14.589L2.48875 14.4334L2.71097 14.3001L2.76653 14.2668L2.83319 14.2334L2.93319 14.1668L3.16653 14.0223L3.36653 13.9112L3.51097 13.8223L3.85541 13.6112L4.17764 13.4112L4.31097 13.3334L4.35541 13.3112L4.5443 13.2001L4.88875 13.0001L4.93319 12.9668L5.01097 12.9223L5.2443 12.789L5.47764 12.6557L5.63319 12.5557L5.92208 12.3779L5.9443 12.3668L6.2443 12.189L6.26653 12.1779L6.36653 12.1112L6.53319 12.0112L6.57764 11.989L6.92208 11.7779L7.26653 11.5779L7.38875 11.5001L7.52208 11.4223L7.73319 11.3001L7.95542 11.1668L8.28875 10.9668L8.36653 10.9223L8.4443 10.8779L8.67764 10.7445L8.83319 10.6445L8.98875 10.5557L9.33319 10.3445L9.4443 10.2779L9.59986 10.189L9.78875 10.0779L10.011 9.94454V0.100098C9.89986 0.111209 9.77764 0.122321 9.66653 0.144543L9.47764 0.188987C9.42208 0.200098 9.36653 0.211209 9.32208 0.244542L9.21097 0.277876L8.97764 0.400099L8.63319 0.588988L8.28875 0.777876L7.95542 0.966765L7.61097 1.15565L7.26653 1.34454L6.92208 1.53343L6.57764 1.72232L6.23319 1.91121L5.88875 2.1001L5.5443 2.28899L5.19986 2.47788L4.85541 2.66676L4.51097 2.86677L4.16653 3.05565L3.82208 3.25565L3.47764 3.45565L3.13319 3.65565L2.78875 3.85565L2.4443 4.06677C2.38875 4.08899 2.3443 4.12232 2.31097 4.14454C2.2443 4.18899 2.16653 4.23343 2.11097 4.28899C1.99986 4.37788 1.88875 4.47788 1.78875 4.57788L1.76653 4.6001C1.63319 4.74454 1.52208 4.91121 1.42208 5.08899C1.23319 5.44454 1.11097 5.84454 1.07764 6.24454V13.889C1.07764 14.0668 1.11097 14.2445 1.16653 14.4112C1.22208 14.589 1.31097 14.7557 1.42208 14.9001C1.45542 14.9445 1.48875 14.989 1.52208 15.0223L1.76653 14.8779L1.86653 14.8223Z"
      fill="url(#paint0_linear_24530_73508)"
    />
    <path
      d="M18.6001 5.26677C18.5224 5.11122 18.4335 4.95566 18.3335 4.81122C18.2779 4.74455 18.2224 4.67789 18.1668 4.61122L18.0557 4.51122C17.9668 4.42233 17.8779 4.34455 17.7779 4.27789C17.7113 4.23344 17.6557 4.189 17.6224 4.16678L17.5113 4.10011L17.2446 3.93344L16.9779 3.77789L16.7001 3.61122L16.4335 3.45567L16.1557 3.30011L15.8779 3.14455L15.6113 2.989L15.3335 2.83344L15.0668 2.67789L14.789 2.52233L14.5113 2.36678L14.2446 2.21122L13.9668 2.05566L13.7001 1.90011L13.4335 1.75566L13.1557 1.61122L12.8779 1.45566L12.6113 1.30011L12.3446 1.15566L12.0668 1.00011L11.8001 0.844554L11.5224 0.688997L11.2557 0.533442L10.989 0.377886L10.7113 0.233443C10.6335 0.200109 10.5446 0.177887 10.4557 0.144553C10.3668 0.122331 10.2779 0.100109 10.189 0.0889977C10.1001 0.0778866 10.0001 0.0667752 9.92236 0.0556641V10.0001L9.96681 10.0223L10.189 10.1668L10.3557 10.2668L10.4668 10.3223L10.5779 10.389L10.6668 10.4446L10.9001 10.5779L11.0446 10.6668L11.2224 10.7779L11.3557 10.8557L11.589 10.989L11.8224 11.1223L12.0557 11.2668L12.289 11.4112L12.5224 11.5446L12.7001 11.6557L12.9113 11.7779L13.0224 11.8446L13.2001 11.9557L13.4001 12.0668L13.4446 12.1001L13.7001 12.2557L13.889 12.3668L14.1224 12.5112L14.2001 12.5557L14.2668 12.589L14.4446 12.689L14.6001 12.7779L14.8335 12.9223L15.0668 13.0557L15.1446 13.1001L15.3668 13.2334L15.6335 13.4001L15.7446 13.4668H15.7668L15.889 13.5334L16.1557 13.7001L16.4335 13.8557L16.7001 14.0223L16.9335 14.1668L16.9779 14.189L17.2335 14.3446L17.2668 14.3668L17.3557 14.4223L17.4446 14.4779L17.5113 14.5223L17.7779 14.6779L17.9113 14.7557L18.0446 14.8334L18.189 14.9112L18.3224 14.989L18.489 15.1001L18.589 14.9557L18.6224 14.9001C18.7001 14.7779 18.7446 14.6334 18.7668 14.489C18.8113 14.3112 18.8446 14.1334 18.8557 13.9557V6.26678C18.8557 5.93344 18.7557 5.57789 18.6001 5.26677Z"
      fill="url(#paint1_linear_24530_73508)"
    />
    <path
      d="M18.3112 14.7777L18.1779 14.6999L18.0446 14.5999L17.9446 14.5444L17.7001 14.411L17.5557 14.3221L17.389 14.2221L17.2446 14.1333L17.1001 14.0444L17.0668 14.0221L17.0224 13.9888L16.789 13.8555L16.5557 13.711L16.3335 13.5666L16.1001 13.4333L15.889 13.311L15.7557 13.2333L15.6335 13.1666L15.4001 13.0333L15.2446 12.9444L15.189 12.911L14.9224 12.7444L14.6446 12.5777L14.5446 12.5221L14.4668 12.4777L14.289 12.3999L14.0779 12.2777L13.8112 12.111L13.7668 12.0666L13.5335 11.9333L13.5001 11.911L13.2779 11.7777L13.1224 11.6888L13.0668 11.6555L12.8335 11.511L12.789 11.4888L12.7224 11.4555L12.4557 11.2888L12.189 11.1221L11.9224 10.9555L11.6446 10.7888L11.3668 10.6333L11.3001 10.5888L11.2001 10.5333L11.1112 10.4777H11.089L10.8112 10.311L10.6446 10.211L10.5224 10.111L10.4557 10.0666L10.289 9.96659L10.0224 9.81104L9.83346 9.92215L9.80013 9.94437L9.67791 10.011L9.45569 10.1444L9.37791 10.1888L9.14458 10.3333L8.91124 10.4777L8.83346 10.5221L8.64458 10.6333L8.3668 10.7999L8.21124 10.8999L7.97791 11.0444L7.74457 11.1888H7.73346L7.61124 11.2666L7.38902 11.3999L7.28902 11.4555L7.05569 11.5999L6.82235 11.7444L6.58902 11.8777L6.52235 11.9221L6.25569 12.0888L6.12235 12.1666L5.92235 12.2999L5.88902 12.311L5.6668 12.4444L5.58902 12.4888L5.53346 12.5221L5.18902 12.7333L4.90013 12.911L4.74457 13.011L4.51124 13.1555L4.32235 13.2666L4.1668 13.3666L4.04458 13.4444L3.81124 13.5888L3.57791 13.7333L3.34457 13.8666L3.31124 13.8888L3.11124 13.9999L2.7668 14.211L2.68902 14.2555L2.41124 14.4333L2.0668 14.6444L1.77791 14.8221L1.70013 14.8666L1.4668 15.011L1.64458 15.1888L1.70013 15.2333C1.77791 15.2999 1.85569 15.3666 1.93346 15.4333C2.01124 15.4999 2.08902 15.5444 2.1668 15.5999L2.40013 15.7555L2.63346 15.8888C2.71124 15.9333 2.78902 15.9666 2.8668 16.011L2.98902 16.0666L3.10013 16.1333L3.33346 16.2777L3.5668 16.411L3.80013 16.5555L4.03346 16.6999L4.2668 16.8333L4.50013 16.9666L4.73346 17.111L4.95569 17.2444L5.18902 17.3777L5.42235 17.511L5.65569 17.6555L5.88902 17.7888L6.12235 17.9221L6.35569 18.0555L6.58902 18.1888L6.82235 18.3221L7.05569 18.4666L7.28902 18.5999L7.51124 18.7333L7.74457 18.8666L7.97791 18.9999L8.21124 19.1333L8.44457 19.2666L8.67791 19.411L8.90013 19.5444L9.12235 19.6777L9.35569 19.7444C9.43346 19.7666 9.51124 19.7888 9.58902 19.7999L9.82235 19.8333H10.2779C10.3557 19.8333 10.4335 19.8221 10.5112 19.811L10.7446 19.7666L10.9779 19.6999L11.0668 19.6666L11.2001 19.5888L11.4335 19.4555L11.6668 19.3221L11.9001 19.1888L12.1335 19.0555L12.3668 18.9221L12.6001 18.7888L12.8335 18.6555L13.0668 18.5221L13.3001 18.3888L13.5335 18.2555L13.7668 18.1221L14.0001 17.9888L14.2335 17.8555L14.4668 17.7221L14.7001 17.5888L14.9335 17.4555L15.1668 17.3221L15.4001 17.1888L15.6335 17.0555L15.8668 16.9221L16.1001 16.7888L16.3335 16.6555L16.5668 16.5221L16.8001 16.3888L17.0335 16.2555L17.2668 16.1221L17.5001 15.9888L17.7335 15.8555L17.8557 15.7777L17.9557 15.711C18.0335 15.6555 18.1112 15.5999 18.189 15.5333C18.2557 15.4666 18.3224 15.3999 18.389 15.3333C18.4001 15.3221 18.4112 15.2999 18.4224 15.2888C18.5112 15.1888 18.589 15.0888 18.6557 14.9777L18.4224 14.8333L18.3112 14.7777Z"
      fill="url(#paint2_linear_24530_73508)"
    />
    <path
      d="M4.17773 13.4223H4.19996L4.35551 13.3223L4.31107 13.3445L4.17773 13.4223Z"
      fill="url(#paint3_linear_24530_73508)"
    />
    <path
      d="M4.17773 13.4223H4.19996L4.35551 13.3223L4.31107 13.3445L4.17773 13.4223Z"
      fill="url(#paint4_linear_24530_73508)"
    />
    <path
      d="M2.47769 14.4445L2.24436 14.5889L2.01102 14.7334L1.85547 14.8334L2.13325 14.6667L2.47769 14.4445L2.76658 14.2778L2.71103 14.3112L2.47769 14.4445Z"
      fill="url(#paint5_linear_24530_73508)"
    />
    <path
      d="M2.47769 14.4445L2.24436 14.5889L2.01102 14.7334L1.85547 14.8334L2.13325 14.6667L2.47769 14.4445L2.76658 14.2778L2.71103 14.3112L2.47769 14.4445Z"
      fill="url(#paint6_linear_24530_73508)"
    />
    <path
      d="M2.94424 14.1777L2.84424 14.2332L3.18868 14.0332L3.37757 13.9221L3.17757 14.0332L2.94424 14.1777Z"
      fill="url(#paint7_linear_24530_73508)"
    />
    <path
      d="M2.94424 14.1777L2.84424 14.2332L3.18868 14.0332L3.37757 13.9221L3.17757 14.0332L2.94424 14.1777Z"
      fill="url(#paint8_linear_24530_73508)"
    />
    <path
      d="M5.91113 12.3888L5.94447 12.3777L5.91113 12.3888Z"
      fill="url(#paint9_linear_24530_73508)"
    />
    <path
      d="M5.91113 12.3888L5.94447 12.3777L5.91113 12.3888Z"
      fill="url(#paint10_linear_24530_73508)"
    />
    <path
      d="M5.23348 12.7889L5.00014 12.9333L4.92236 12.9778L5.22236 12.8L5.56681 12.6L5.62237 12.5667L5.46681 12.6667L5.23348 12.7889Z"
      fill="url(#paint11_linear_24530_73508)"
    />
    <path
      d="M5.23348 12.7889L5.00014 12.9333L4.92236 12.9778L5.22236 12.8L5.56681 12.6L5.62237 12.5667L5.46681 12.6667L5.23348 12.7889Z"
      fill="url(#paint12_linear_24530_73508)"
    />
    <path
      d="M8.44448 10.8556L8.3667 10.9001L8.63337 10.7334L8.82225 10.6223L8.6667 10.7223L8.44448 10.8556Z"
      fill="url(#paint13_linear_24530_73508)"
    />
    <path
      d="M8.44448 10.8556L8.3667 10.9001L8.63337 10.7334L8.82225 10.6223L8.6667 10.7223L8.44448 10.8556Z"
      fill="url(#paint14_linear_24530_73508)"
    />
    <path
      d="M6.27783 12.1667L6.5445 12L6.37783 12.1L6.27783 12.1667Z"
      fill="url(#paint15_linear_24530_73508)"
    />
    <path
      d="M6.27783 12.1667L6.5445 12L6.37783 12.1L6.27783 12.1667Z"
      fill="url(#paint16_linear_24530_73508)"
    />
    <path
      d="M9.43311 10.2557L9.65533 10.1223L9.76644 10.0557L9.57755 10.1668L9.43311 10.2557Z"
      fill="url(#paint17_linear_24530_73508)"
    />
    <path
      d="M9.43311 10.2557L9.65533 10.1223L9.76644 10.0557L9.57755 10.1668L9.43311 10.2557Z"
      fill="url(#paint18_linear_24530_73508)"
    />
    <path
      d="M7.38867 11.4889L7.61089 11.3556L7.73312 11.2778L7.52201 11.4112L7.38867 11.4889Z"
      fill="url(#paint19_linear_24530_73508)"
    />
    <path
      d="M7.38867 11.4889L7.61089 11.3556L7.73312 11.2778L7.52201 11.4112L7.38867 11.4889Z"
      fill="url(#paint20_linear_24530_73508)"
    />
    <path
      d="M18.1998 14.8111L18.0664 14.7333L17.9331 14.6555L18.0664 14.7444L18.1998 14.8111Z"
      fill="url(#paint21_linear_24530_73508)"
    />
    <path
      d="M18.1998 14.8111L18.0664 14.7333L17.9331 14.6555L18.0664 14.7444L18.1998 14.8111Z"
      fill="url(#paint22_linear_24530_73508)"
    />
    <path
      d="M17.022 14.1L16.9775 14.0667L17.0109 14.0889L17.022 14.1Z"
      fill="url(#paint23_linear_24530_73508)"
    />
    <path
      d="M17.022 14.1L16.9775 14.0667L17.0109 14.0889L17.022 14.1Z"
      fill="url(#paint24_linear_24530_73508)"
    />
    <path
      d="M14.8446 12.8C14.9335 12.8555 15.0224 12.9111 15.1112 12.9555L15.1668 12.9889L15.089 12.9444L14.8557 12.8111L14.6224 12.6778L14.4668 12.5889L14.5668 12.6444L14.8446 12.8Z"
      fill="url(#paint25_linear_24530_73508)"
    />
    <path
      d="M14.8446 12.8C14.9335 12.8555 15.0224 12.9111 15.1112 12.9555L15.1668 12.9889L15.089 12.9444L14.8557 12.8111L14.6224 12.6778L14.4668 12.5889L14.5668 12.6444L14.8446 12.8Z"
      fill="url(#paint26_linear_24530_73508)"
    />
    <path
      d="M17.3555 14.3222L17.2666 14.2666L17.4333 14.3666L17.3555 14.3222Z"
      fill="url(#paint27_linear_24530_73508)"
    />
    <path
      d="M17.3555 14.3222L17.2666 14.2666L17.4333 14.3666L17.3555 14.3222Z"
      fill="url(#paint28_linear_24530_73508)"
    />
    <path
      d="M10.4333 10.1666L10.2778 10.0666L10.0444 9.94434L10 9.92212L10.2667 10.0777L10.4333 10.1666Z"
      fill="url(#paint29_linear_24530_73508)"
    />
    <path
      d="M10.4333 10.1666L10.2778 10.0666L10.0444 9.94434L10 9.92212L10.2667 10.0777L10.4333 10.1666Z"
      fill="url(#paint30_linear_24530_73508)"
    />
    <path
      d="M15.7669 13.3667L15.6558 13.3L15.7891 13.3778L15.7669 13.3667Z"
      fill="url(#paint31_linear_24530_73508)"
    />
    <path
      d="M15.7669 13.3667L15.6558 13.3L15.7891 13.3778L15.7669 13.3667Z"
      fill="url(#paint32_linear_24530_73508)"
    />
    <path
      d="M11.6109 10.8779L11.8776 11.0334L12.1443 11.2001L12.4109 11.3556L12.6776 11.5112L12.7331 11.5445L12.5443 11.4334L12.3109 11.3001L12.0887 11.1556L11.8554 11.0223L11.622 10.889L11.3887 10.7556L11.2554 10.6667L11.322 10.7112L11.6109 10.8779Z"
      fill="url(#paint33_linear_24530_73508)"
    />
    <path
      d="M11.6109 10.8779L11.8776 11.0334L12.1443 11.2001L12.4109 11.3556L12.6776 11.5112L12.7331 11.5445L12.5443 11.4334L12.3109 11.3001L12.0887 11.1556L11.8554 11.0223L11.622 10.889L11.3887 10.7556L11.2554 10.6667L11.322 10.7112L11.6109 10.8779Z"
      fill="url(#paint34_linear_24530_73508)"
    />
    <path
      d="M11.0777 10.5555H11.1L10.9555 10.4777L10.7222 10.3444L10.6333 10.2888L10.8 10.3888L11.0777 10.5555Z"
      fill="url(#paint35_linear_24530_73508)"
    />
    <path
      d="M11.0777 10.5555H11.1L10.9555 10.4777L10.7222 10.3444L10.6333 10.2888L10.8 10.3888L11.0777 10.5555Z"
      fill="url(#paint36_linear_24530_73508)"
    />
    <path
      d="M14.0331 12.3222L14.2443 12.4444L14.1665 12.3889L13.9443 12.2666L13.7554 12.1555L14.0331 12.3222Z"
      fill="url(#paint37_linear_24530_73508)"
    />
    <path
      d="M14.0331 12.3222L14.2443 12.4444L14.1665 12.3889L13.9443 12.2666L13.7554 12.1555L14.0331 12.3222Z"
      fill="url(#paint38_linear_24530_73508)"
    />
    <path
      d="M13.4444 11.9778L13.2666 11.8667L13.0889 11.7556L13.2444 11.8445L13.4444 11.9778Z"
      fill="url(#paint39_linear_24530_73508)"
    />
    <path
      d="M13.4444 11.9778L13.2666 11.8667L13.0889 11.7556L13.2444 11.8445L13.4444 11.9778Z"
      fill="url(#paint40_linear_24530_73508)"
    />
    <path
      d="M6.81131 14.4778H5.7002V11.4111C5.71131 10.9666 6.07797 10.6 6.52242 10.6111H7.63353V13.6778C7.62242 14.1222 7.25575 14.4889 6.81131 14.4778Z"
      fill="white"
    />
    <path
      d="M13.5667 14.4779H12.4556V8.06674C12.4667 7.61119 12.8111 7.23341 13.2556 7.18896H14.3778V13.6001C14.3333 13.8001 14.2444 13.9779 14.1111 14.1334C13.9778 14.3001 13.7889 14.4223 13.5667 14.4779Z"
      fill="white"
    />
    <path
      d="M10.1443 14.4778H9.0332V5.61116C9.05543 5.32227 9.22209 5.0556 9.46654 4.91115C9.58876 4.8556 9.71098 4.82227 9.84431 4.82227H10.9554V13.6889C10.9332 13.8889 10.8332 14.0778 10.6888 14.2223C10.5443 14.3667 10.3554 14.4556 10.1443 14.4778Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_24530_73508"
        x1="1.12764"
        y1="7.54065"
        x2="9.99986"
        y2="7.54065"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4045A2" />
        <stop offset="1" stopColor="#365FB3" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_24530_73508"
        x1="9.91125"
        y1="7.60622"
        x2="18.8657"
        y2="7.60622"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1D75C0" />
        <stop offset="1" stopColor="#0F95D6" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_24530_73508"
        x1="1.51235"
        y1="14.8121"
        x2="18.6179"
        y2="14.8121"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3164BC" />
        <stop offset="1" stopColor="#1BA2D9" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_24530_73508"
        x1="1.12774"
        y1="13.3689"
        x2="9.99994"
        y2="13.3689"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4045A2" />
        <stop offset="1" stopColor="#365FB3" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_24530_73508"
        x1="1.56441"
        y1="13.3689"
        x2="18.5199"
        y2="13.3689"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3164BC" />
        <stop offset="1" stopColor="#1BA2D9" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_24530_73508"
        x1="1.12769"
        y1="14.5445"
        x2="9.99993"
        y2="14.5445"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4045A2" />
        <stop offset="1" stopColor="#365FB3" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_24530_73508"
        x1="1.56436"
        y1="14.5445"
        x2="18.52"
        y2="14.5445"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3164BC" />
        <stop offset="1" stopColor="#1BA2D9" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_24530_73508"
        x1="1.12757"
        y1="14.0827"
        x2="9.9998"
        y2="14.0827"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4045A2" />
        <stop offset="1" stopColor="#365FB3" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_24530_73508"
        x1="1.56424"
        y1="14.0827"
        x2="18.5198"
        y2="14.0827"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3164BC" />
        <stop offset="1" stopColor="#1BA2D9" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_24530_73508"
        x1="1.12774"
        y1="12.3805"
        x2="10.0001"
        y2="12.3805"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4045A2" />
        <stop offset="1" stopColor="#365FB3" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_24530_73508"
        x1="1.56441"
        y1="12.3805"
        x2="18.5202"
        y2="12.3805"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3164BC" />
        <stop offset="1" stopColor="#1BA2D9" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_24530_73508"
        x1="1.1279"
        y1="12.7683"
        x2="10.0002"
        y2="12.7683"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4045A2" />
        <stop offset="1" stopColor="#365FB3" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_24530_73508"
        x1="1.56457"
        y1="12.7683"
        x2="18.5202"
        y2="12.7683"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3164BC" />
        <stop offset="1" stopColor="#1BA2D9" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_24530_73508"
        x1="1.12782"
        y1="10.764"
        x2="10"
        y2="10.764"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4045A2" />
        <stop offset="1" stopColor="#365FB3" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_24530_73508"
        x1="1.56449"
        y1="10.764"
        x2="18.52"
        y2="10.764"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3164BC" />
        <stop offset="1" stopColor="#1BA2D9" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_24530_73508"
        x1="1.1279"
        y1="12.0844"
        x2="10"
        y2="12.0844"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4045A2" />
        <stop offset="1" stopColor="#365FB3" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_24530_73508"
        x1="1.56456"
        y1="12.0844"
        x2="18.5199"
        y2="12.0844"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3164BC" />
        <stop offset="1" stopColor="#1BA2D9" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_24530_73508"
        x1="1.12756"
        y1="10.1529"
        x2="9.99977"
        y2="10.1529"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4045A2" />
        <stop offset="1" stopColor="#365FB3" />
      </linearGradient>
      <linearGradient
        id="paint18_linear_24530_73508"
        x1="1.56422"
        y1="10.1529"
        x2="18.5198"
        y2="10.1529"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3164BC" />
        <stop offset="1" stopColor="#1BA2D9" />
      </linearGradient>
      <linearGradient
        id="paint19_linear_24530_73508"
        x1="1.12753"
        y1="11.3845"
        x2="9.9998"
        y2="11.3845"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4045A2" />
        <stop offset="1" stopColor="#365FB3" />
      </linearGradient>
      <linearGradient
        id="paint20_linear_24530_73508"
        x1="1.5642"
        y1="11.3845"
        x2="18.5198"
        y2="11.3845"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3164BC" />
        <stop offset="1" stopColor="#1BA2D9" />
      </linearGradient>
      <linearGradient
        id="paint21_linear_24530_73508"
        x1="9.99981"
        y1="14.7333"
        x2="18.872"
        y2="14.7333"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1D75C0" />
        <stop offset="1" stopColor="#0F95D6" />
      </linearGradient>
      <linearGradient
        id="paint22_linear_24530_73508"
        x1="1.56423"
        y1="14.7333"
        x2="18.5198"
        y2="14.7333"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3164BC" />
        <stop offset="1" stopColor="#1BA2D9" />
      </linearGradient>
      <linearGradient
        id="paint23_linear_24530_73508"
        x1="9.99997"
        y1="14.0833"
        x2="18.8719"
        y2="14.0833"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1D75C0" />
        <stop offset="1" stopColor="#0F95D6" />
      </linearGradient>
      <linearGradient
        id="paint24_linear_24530_73508"
        x1="1.56466"
        y1="14.0833"
        x2="18.5197"
        y2="14.0833"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3164BC" />
        <stop offset="1" stopColor="#1BA2D9" />
      </linearGradient>
      <linearGradient
        id="paint25_linear_24530_73508"
        x1="10.0001"
        y1="12.7922"
        x2="18.8724"
        y2="12.7922"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1D75C0" />
        <stop offset="1" stopColor="#0F95D6" />
      </linearGradient>
      <linearGradient
        id="paint26_linear_24530_73508"
        x1="1.56456"
        y1="12.7922"
        x2="18.5201"
        y2="12.7922"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3164BC" />
        <stop offset="1" stopColor="#1BA2D9" />
      </linearGradient>
      <linearGradient
        id="paint27_linear_24530_73508"
        x1="9.99996"
        y1="14.3244"
        x2="18.8722"
        y2="14.3244"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1D75C0" />
        <stop offset="1" stopColor="#0F95D6" />
      </linearGradient>
      <linearGradient
        id="paint28_linear_24530_73508"
        x1="1.56444"
        y1="14.3244"
        x2="18.5199"
        y2="14.3244"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3164BC" />
        <stop offset="1" stopColor="#1BA2D9" />
      </linearGradient>
      <linearGradient
        id="paint29_linear_24530_73508"
        x1="10"
        y1="10.0421"
        x2="18.8722"
        y2="10.0421"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1D75C0" />
        <stop offset="1" stopColor="#0F95D6" />
      </linearGradient>
      <linearGradient
        id="paint30_linear_24530_73508"
        x1="1.56446"
        y1="10.0421"
        x2="18.52"
        y2="10.0421"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3164BC" />
        <stop offset="1" stopColor="#1BA2D9" />
      </linearGradient>
      <linearGradient
        id="paint31_linear_24530_73508"
        x1="10.0002"
        y1="13.3362"
        x2="18.8724"
        y2="13.3362"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1D75C0" />
        <stop offset="1" stopColor="#0F95D6" />
      </linearGradient>
      <linearGradient
        id="paint32_linear_24530_73508"
        x1="1.56456"
        y1="13.3362"
        x2="18.5202"
        y2="13.3362"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3164BC" />
        <stop offset="1" stopColor="#1BA2D9" />
      </linearGradient>
      <linearGradient
        id="paint33_linear_24530_73508"
        x1="9.99981"
        y1="11.1145"
        x2="18.872"
        y2="11.1145"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1D75C0" />
        <stop offset="1" stopColor="#0F95D6" />
      </linearGradient>
      <linearGradient
        id="paint34_linear_24530_73508"
        x1="1.56426"
        y1="11.1145"
        x2="18.5198"
        y2="11.1145"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3164BC" />
        <stop offset="1" stopColor="#1BA2D9" />
      </linearGradient>
      <linearGradient
        id="paint35_linear_24530_73508"
        x1="9.99997"
        y1="10.4255"
        x2="18.8722"
        y2="10.4255"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1D75C0" />
        <stop offset="1" stopColor="#0F95D6" />
      </linearGradient>
      <linearGradient
        id="paint36_linear_24530_73508"
        x1="1.56442"
        y1="10.4255"
        x2="18.52"
        y2="10.4255"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3164BC" />
        <stop offset="1" stopColor="#1BA2D9" />
      </linearGradient>
      <linearGradient
        id="paint37_linear_24530_73508"
        x1="9.99982"
        y1="12.3033"
        x2="18.872"
        y2="12.3033"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1D75C0" />
        <stop offset="1" stopColor="#0F95D6" />
      </linearGradient>
      <linearGradient
        id="paint38_linear_24530_73508"
        x1="1.56426"
        y1="12.3033"
        x2="18.5198"
        y2="12.3033"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3164BC" />
        <stop offset="1" stopColor="#1BA2D9" />
      </linearGradient>
      <linearGradient
        id="paint39_linear_24530_73508"
        x1="9.99991"
        y1="11.8623"
        x2="18.8723"
        y2="11.8623"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1D75C0" />
        <stop offset="1" stopColor="#0F95D6" />
      </linearGradient>
      <linearGradient
        id="paint40_linear_24530_73508"
        x1="1.56418"
        y1="11.8623"
        x2="18.5201"
        y2="11.8623"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3164BC" />
        <stop offset="1" stopColor="#1BA2D9" />
      </linearGradient>
    </defs>
  </SvgIcon>
);
